import apiClient from './api'

export const roleService = {
  /**
   * Get all available permissions
   * @returns {Promise} Array of permission objects with id and name
   */
  async getPermissions() {
    try {
      const response = await apiClient.get('/admin/roles/permissions')
      return {
        success: true,
        data: response.data.data || []
      }
    } catch (error) {
      console.error('Get permissions error:', error)
      throw new Error(error.response?.data?.message || 'فشل في جلب الصلاحيات')
    }
  },

  /**
   * Get all roles
   * @returns {Promise} Array of role objects
   */
  async getRoles() {
    try {
      const response = await apiClient.get('/admin/roles')
      return {
        success: true,
        data: response.data.data || []
      }
    } catch (error) {
      console.error('Get roles error:', error)
      throw new Error(error.response?.data?.message || 'فشل في جلب الأدوار')
    }
  },

  /**
   * Create a new role
   * @param {Object} roleData - Role data {name, desc, permissions}
   * @returns {Promise} Created role object
   */
  async createRole(roleData) {
    try {
      const response = await apiClient.post('/admin/roles', {
        name: roleData.name,
        desc: roleData.desc || roleData.description,
        permissions: roleData.permissions || []
      })
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || 'تم إنشاء الدور بنجاح'
      }
    } catch (error) {
      console.error('Create role error:', error)
      throw new Error(error.response?.data?.message || 'فشل في إنشاء الدور')
    }
  },

  /**
   * Update an existing role
   * @param {number} roleId - Role ID
   * @param {Object} roleData - Updated role data {name, desc, permissions}
   * @returns {Promise} Updated role object
   */
  async updateRole(roleId, roleData) {
    try {
      const response = await apiClient.put(`/admin/roles/${roleId}`, {
        name: roleData.name,
        desc: roleData.desc || roleData.description,
        permissions: roleData.permissions || []
      })
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || 'تم تحديث الدور بنجاح'
      }
    } catch (error) {
      console.error('Update role error:', error)
      throw new Error(error.response?.data?.message || 'فشل في تحديث الدور')
    }
  },



  /**
   * Helper function to map permission IDs to permission names
   * @param {Array} permissionIds - Array of permission IDs
   * @param {Array} allPermissions - Array of all available permissions
   * @returns {Array} Array of permission names
   */
  mapPermissionIdsToNames(permissionIds, allPermissions) {
    const permissionMap = {}
    allPermissions.forEach(perm => {
      permissionMap[perm.id] = perm.name
    })
    
    return permissionIds.map(id => permissionMap[id]).filter(Boolean)
  },

  /**
   * Helper function to map permission names to permission IDs
   * @param {Array} permissionNames - Array of permission names
   * @param {Array} allPermissions - Array of all available permissions
   * @returns {Array} Array of permission IDs
   */
  mapPermissionNamesToIds(permissionNames, allPermissions) {
    const permissionMap = {}
    allPermissions.forEach(perm => {
      permissionMap[perm.name] = perm.id
    })
    
    return permissionNames.map(name => permissionMap[name]).filter(Boolean)
  }
}

export default roleService 